import { Box, Skeleton, Stack } from "@mui/material";

const ProblemSkeleton = () => {
  return (
    <Box
      sx={{
        width: "100%",
        mb: 2,
      }}
    >
      <Box
        sx={{
          py: 1,
          px: 1.5,
          borderBottom: "1px solid rgba(28, 72, 46, 0.45)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Skeleton
          variant="text"
          height={20}
          width="34%"
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
      </Box>

      <Box
        sx={{
          pt: 1.5,
          pb: 1,
          px: 1.5,
        }}
      >
        <Skeleton
          variant="rounded"
          width={88}
          height={22}
          sx={{
            mb: 1.5,
            borderRadius: 5,
            bgcolor: "background.paper",
          }}
        />
        <Skeleton
          variant="text"
          height={20}
          width="100%"
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="text"
          height={20}
          width="90%"
          sx={{ mb: 1.5, bgcolor: "background.paper" }}
        />

        <Stack spacing={1}>
          {[1, 2, 3, 4].map((item) => (
            <Box
              key={item}
              sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
            >
              <Skeleton
                variant="circular"
                width={16}
                height={16}
                sx={{ bgcolor: "background.paper" }}
              />
              <Skeleton
                variant="text"
                height={18}
                width={`${78 - item * 8}%`}
                sx={{ bgcolor: "background.paper" }}
              />
            </Box>
          ))}
        </Stack>
      </Box>

      <Stack
        direction="row"
        spacing={0.75}
        sx={{
          py: 0.5,
          px: 1.5,
          justifyContent: "flex-end",
        }}
      >
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
      </Stack>
    </Box>
  );
};

export default ProblemSkeleton;
